import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CreateReminderDialogService {
  public dueDateValue: Date; // = new Date("Sat Aug 28 2021 00:00:00 GMT+0200");
  // public dueDateValueChange: Subject<Date> = new Subject<Date>();
  public dueDateValueChange = new Subject<any>();
  public remindersDate: [];
  public constructor() {
    this.dueDateValueChange.subscribe(value => {
      this.dueDateValue = value;
    });
  }

  public setFeedbackDueDate(fddDate: Date): void {
    this.dueDateValueChange.next(fddDate);
  }

  public getFeedbackDueDate(): Date {
    return this.dueDateValue;
  }

  public setRemindersDate(reminders: any): void {
    this.remindersDate = reminders;
  }

  public getRemindersDate(): [] {
    return this.remindersDate;
  }
  public calculateDateDiff() {
    const currentDate = new Date();
    const dueDate = new Date(this.dueDateValue);

    return Math.floor((Date.UTC(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate()) - Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())) / (1000 * 60 * 60 * 24));
  }
}
